import React from "react";
import { useHistory } from "react-router-dom";

import SimpleButton, { SimpleButtonProps } from "./SimpleButton/SimpleButton";

export interface LinkButtonProps extends Omit<SimpleButtonProps, "as"> {
  to: string;
  id: string;
  state?: Record<string, unknown>;
}

const LinkButton: React.FC<LinkButtonProps> = ({
  to,
  children,
  state,
  onClick,
  ...props
}) => {
  const history = useHistory();
  const click = (event: any) => {
    if (onClick) onClick(event);
    if (to) history.push(to, state);
  };
  return (
    <SimpleButton onClick={click} {...props}>
      {children}
    </SimpleButton>
  );
};

export default LinkButton;
